<template>
  <div id="mailBounces" class="tab-pane">
    <LogFilterBox @apply="getBounces(1)" @clear="clearSearch">
      <div class="form-row align-items-end">
        <div class="col-12 col-md-6">
          <label for="recipient" class="form-label">{{
            trans("admin.logFilterEmailAddress")
          }}</label>
          <input
            id="recipient"
            v-model="searchFields.recipient"
            type="text"
            class="form-control"
            name="recipient"
            data-test="mail-bounce-recipient-filter"
          />
        </div>
      </div>

      <div class="form-row align-items-end mt-3">
        <div class="col-12 col-md-6">
          <label class="form-label">{{
            trans("evaluation.tableColumnCreatedAtFrom")
          }}</label>
          <custom-datepicker
            :date="searchFields.dateFrom"
            :placeholder="trans('evaluation.tableColumnCreatedAtFrom')"
            @on-date-change="changeDates('dateFrom', $event)"
          />
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">{{
            trans("evaluation.tableColumnCreatedAtTo")
          }}</label>
          <custom-datepicker
            :date="searchFields.dateUntil"
            :placeholder="trans('evaluation.tableColumnCreatedAtTo')"
            @on-date-change="changeDates('dateUntil', $event)"
          />
        </div>
      </div>
    </LogFilterBox>

    <clip-loader v-if="loading" />

    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="sortable-table-header">
          <tr>
            <th>{{ trans("evaluation.tableColumnCreatedAt") }}</th>
            <th>{{ trans("admin.logColumnEmailAddress") }}</th>
            <th>{{ trans("admin.logColumnUser") }}</th>
            <th>{{ trans("admin.mailBounceColumnCause") }}</th>
            <th>{{ trans("admin.logColumnSubject") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="bounce in bounces"
            :key="bounce.id"
            data-test="mail-bounce-row"
          >
            <td>{{ formatDate(bounce.created_at) }}</td>
            <td>{{ bounce.recipient }}</td>
            <td>
              <router-link
                v-if="bounce.user"
                :to="`/admin/users/${bounce.user.id}`"
              >
                {{ bounce.user.name }}
              </router-link>
              <span v-else class="text-muted">—</span>
            </td>
            <td>{{ bounce.cause }}</td>
            <td>{{ bounce.subject }}</td>
          </tr>
          <tr v-if="!loading && bounces.length === 0">
            <td colspan="5" class="text-center text-muted">
              {{ trans("admin.mailBounceEmpty") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row-fluid pull-right">
      <DerPaginate
        v-model="paginate.current_page"
        :page-count="paginate.last_page"
        :show-go="true"
        @change="getBounces"
      />
    </div>
  </div>
</template>

<script>
import DerPaginate from "../../../design-system/DerPaginate.vue";
import LogFilterBox from "./LogFilterBox.vue";
import { queryStringBuilder } from "../../../helpers/misc";
import { practitionerHttpService } from "../../../app/practitioner-portal/store/practitioner-http-service";
import moment from "moment/moment";

export default {
  components: { DerPaginate, LogFilterBox },
  data() {
    return {
      loading: true,
      paginate: {
        current_page: 0,
        total: 0,
        last_page: 0,
      },
      bounces: [],
      searchFields: {
        recipient: "",
        dateFrom: "",
        dateUntil: "",
        page: 1,
      },
    };
  },
  created() {
    this.getBounces(1);
  },
  methods: {
    getBounces(page) {
      this.loading = true;
      this.searchFields.page = page || this.searchFields.page;
      practitionerHttpService
        .get(
          "/api/internal/admin/logs/mail-bounces?" +
            queryStringBuilder(this.searchFields),
        )
        .then((response) => {
          this.paginate = response.data.paginate;
          this.bounces = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.userErrorMessage(error);
        });
    },
    clearSearch() {
      this.searchFields.recipient = "";
      this.searchFields.dateFrom = "";
      this.searchFields.dateUntil = "";
      this.getBounces(1);
    },
    changeDates(field, value) {
      this.searchFields[field] = value;
    },
    formatDate(value) {
      return value ? moment(value).format("YYYY-MM-DD HH:mm") : "";
    },
  },
};
</script>
